import { useEffect, useState, useCallback } from "react";

import LightOnIcon from "../../../assets/lightbulb-svgrepo-com.svg?react";
import LightOffIcon from "../../../assets/lightbulb-slash-svgrepo-com.svg?react";

import "./RealDarkMode.css";
import NfsButton from "../../genericComponents/NfsButton/NfsButton";
const RealDarkMode = () => {
    const [enabled, setEnabled] = useState(false);


    // Handler updates clip-path of overlay to create torch effect
    const handlePointerMove = useCallback((event: PointerEvent) => {
        const overlay = document.querySelector(".real-dark-mode");
        if (overlay instanceof HTMLDivElement) {
            overlay.style.setProperty('--x', `${event.clientX}px`);
            overlay.style.setProperty('--y', `${event.clientY}px`);
        }
    }, []);

    const addRealDarkmodeToBody = () => {
        const realDarkmodeDiv = document.createElement("div");
        realDarkmodeDiv.classList.add("real-dark-mode");
        document.body.appendChild(realDarkmodeDiv);

        document.removeEventListener("pointermove", handlePointerMove);
        document.addEventListener("pointermove", handlePointerMove);
    }

    const removeRealDarkmodeFromBody = () => {
        const realDarkmodeDiv = document.querySelector(".real-dark-mode");
        if (realDarkmodeDiv) {
            (realDarkmodeDiv as HTMLDivElement).style.removeProperty('--x');
            (realDarkmodeDiv as HTMLDivElement).style.removeProperty('--y');
            document.body.removeChild(realDarkmodeDiv);
        }

        document.removeEventListener("pointermove", handlePointerMove);
    }

    useEffect(() => {
        if (enabled) {
            addRealDarkmodeToBody();
        } else {
            removeRealDarkmodeFromBody();
        }
    }, [enabled]);

    return (
        <div className="real-dark-mode-button">
            <NfsButton title={enabled ? "Slå på lyset" : "Slå av lyset"} round onClick={() => setEnabled(!enabled)}>
                {enabled ? <LightOnIcon style={{ width: "24px", height: "24px" }} /> : <LightOffIcon style={{ width: "24px", height: "24px" }} />}
            </NfsButton>
        </div>
    );
};

export default RealDarkMode;